import { createAsyncThunk } from "@reduxjs/toolkit"
import { getRequest } from "./utils/GetRequest"
import { AppPersona } from "../model/app-persona/AppPersona.model"
import { RootState } from "../root-redux/RootState";

export const getAppPersonaBySubKey = createAsyncThunk<AppPersona[], {subkey: string}, {state: RootState}>('apppersonamappings/getAppPersonaBySubkey', async ({subkey} ,{ getState }) => {
  const selectedEnv = getState().env.selectedEnvItem  
  const response = await getRequest<AppPersona[]>(`${selectedEnv}/apppersonamappings?subscriptionKey=${subkey}`);
    return response.data
  });